// Response language detection (TL-1 migration from aiUtils.js).
// Hangul/hiragana-katakana/CJK 우선, 기본 한국어.
// Used by placeholderSubstitute unitOf() to choose dimension unit per language.
export function detectResponseLanguage(text) {
  if (!text || typeof text !== 'string') return 'ko';
  if (/[가-힣]/.test(text)) return 'ko';
  if (/[ぁ-んァ-ヶー]/.test(text)) return 'ja';
  if (/[A-Za-z]/.test(text) && !/[一-龥]/.test(text)) return 'en';
  return 'ko';
}
